import styled from 'styled-components';
import { sizes } from '../themes/sizes';

export const PageContainer = styled.section`
  margin: ${sizes.padding.big};
  display: grid;
  grid-template-rows: 1fr auto;
`;
